import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import { apiUrl } from "../config/url";
import Modal from "react-modal"; // Ensure this is installed
import { toast } from "react-toastify";

function Home() {
  const [modalMessage, setModalMessage] = useState("");
  const [itemSearch, setItemSearch] = useState("");
  const [labourSearch, setLabourSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [itemMasters, setItemMasters] = useState([]);
  const [filteredItemMasters, setFilteredItemMasters] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("api_token");
  const today = new Date().toISOString().split("T")[0];
  const timeoutRef = useRef(null);
  const itemCacheRef = useRef({}); // Cache for item details

  const [quotationData, setQuotationData] = useState({
    quotationNo: "",
    quotDate: "",
    partyName: "",
    refPerson: "",
    partyPersonName: "",
    calculationBy: "",
    glassAmount: 0,
    labourAmount: 0,
    totalAmount: 0,
    netAmount: 0,
    afterAdvanceNetAmount: 0,
    remark: "",
    showCName: "2",
    discOnLabAmt: 0,
    discLabAmount: 0,
    totalAmountWithLabDisc: 0,
    otherCharges: 0,
    gstLabAmt: 0,
    gstAmount: 0,
    discOnGlassAmt: 0,
    discGlassAmount: 0,
    otherChargesGlass: 0,
    gstGlassAmtPercent: 18,
    gstGlassAmt: 0,
    gstPercentGlass: 0,
    totalGstAmountGlass: 0,
    showGSTGlass: '2',
    gstLabAmtPercent: 0,
    advance: 0,
    gstPercent: 0,
    quotDate: today,
  });
  const toFixedFloat = (value, decimals = 2) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : parseFloat(num.toFixed(decimals));
  };

  const handleCalculationByChange = (e) => {
    const value = e.target.value;
    // Check if the value is one of the allowed digits
    if (["1", "3", "6", "9", "12"].includes(value) || value === "") {
      handleChange(e); // Call the original handler if valid
    } else {
      e.preventDefault(); // Prevent invalid input
    }
  };
  const isDisabled = !quotationData.calculationBy;



  const [items, setItems] = useState([
    {
      code: "",
      name: "",
      length: "",
      width: "",
      cal: "",
      quantity: "",
      squareFeet: "",
      rate: "",
      amount: "",
    },
  ]);

  const handleKeyDown = (index, columnIndex, e) => {
    if (e.key === "Tab" && index === items.length - 1 && columnIndex === 10) {
      e.preventDefault();
      addNewItem();
    }
  };

  const removeItem = (index) => {
    // Update the state to remove the item at the given index
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
    handleItemWiseValueChange();
  };

  const fetchItemData = async (code) => {
    if (!code) return { itemName: "", unitShort: "", itemTypeId: "" };
    
    // Check cache first
    if (itemCacheRef.current[code]) {
      return itemCacheRef.current[code];
    }

    try {
      const response = await fetch(
        `${apiUrl}/admin/getItemSingle?item_id=${code}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            api_token: token,
          },
        }
      );

      const result = await response.json();

      if (result.status && result.data) {
        const data = {
          itemName: result.data.item_name || "",
          unitShort: result.data.unit_short || "",
          itemTypeId: result.data.item_type_id || "",
        };
        // Store in cache
        itemCacheRef.current[code] = data;
        return data;
      } else {
        console.error("Failed to fetch valid data from API");
        return { itemName: "", unitShort: "", itemTypeId: "" };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return { itemName: "", unitShort: "", itemTypeId: "" };
    }
  };

  const fetchRefPersonNameById = async (coId) => {
    try {
      console.log(coId);
      // Fetch the data from the API
      const response = await fetch(
        `${apiUrl}/admin/getCoMasterSingle?co_id=${coId}`, // Fixed template literal
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            api_token: token, // Replace with your actual API token
          },
        }
      );

      const result = await response.json();

      // Check if the status is true and data is not null
      if (result.status && result.data) {
        // Return the corresponding name based on coId
        return result.data.name || "";
      } else {
        console.error("Failed to fetch valid data from API");
        return "";
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return "";
    }
  };

  const fetchItemMasters = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("api_token");
      const response = await axios.get(`${apiUrl}/admin/getAllItems`, {
        headers: { api_token: token },
      });

      if (Array.isArray(response.data.data)) {
        setItemMasters(response.data.data);
        setFilteredItemMasters(response.data.data); // Initialize filtered list
      } else {
        console.error("Expected an array but got:", response.data);
        toast.error("Failed to fetch records");
      }
    } catch (error) {
      console.error("Error fetching item masters", error);
      toast.error("Failed to fetch records");
    } finally {
      setLoading(false);
    }
  };

  const openModal = async () => {
    await fetchItemMasters(); // Fetch data before opening modal
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleInputChange = async (event) => {
    const { name, value } = event.target;

    // Update `C/O Id` and fetch the corresponding `Ref. Person Name`
    if (name === "coId") {
      const refPersonName = await fetchRefPersonNameById(value);
      setQuotationData((prevData) => ({
        ...prevData,
        coId: value,
        refPerson: refPersonName,
      }));
    } else {
      setQuotationData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleShowGSTGlass = (e) => {

    const updatedData = { ...quotationData };
    const {
      advance = 0,
    } = updatedData;
    if (e.target.value == '1') {
      updatedData.showGSTGlass = '1';
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt + updatedData.gstGlassAmt
      );
      console.log("Going Inside");
    } else {
      updatedData.showGSTGlass = '2';
      console.log("Evertythinh", updatedData.labourAmount, updatedData.glassAmount, updatedData.gstGlassAmt);
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount + updatedData.gstGlassAmt - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt
      );

    }
    updatedData.netAmount = toFixedFloat(
      updatedData.totalAmount + updatedData.gstAmount
    );
    updatedData.afterAdvanceNetAmount = toFixedFloat(
      updatedData.netAmount - advance
    );
    setQuotationData(updatedData);


  }

  const handleItemWiseValueChange = () => {
    let initialTotalAmount = 0;
    let initialLabourAmount = 0;
    let initialGlassAmount = 0;

    items.forEach((item) => {
      const amount = toFixedFloat(item?.amount);
      initialTotalAmount += amount;

      if (item?.item_type_id === 1) {
        initialGlassAmount += amount;
      }

      if (item?.item_type_id === 2) {
        initialLabourAmount += amount;
      }
    });

    const updatedData = { ...quotationData };

    const {
      otherCharges = 0,
      gstLabAmtPercent = 0,
      discOnLabAmt = 0,
      otherChargesGlass = 0,
      discOnGlassAmt = 0,
      advance = 0,
    } = updatedData;

    updatedData.discLabAmount = (initialLabourAmount * discOnLabAmt) / 100;
    updatedData.gstLabAmt = toFixedFloat(
      (initialLabourAmount * gstLabAmtPercent) / 100
    );
    updatedData.labourAmount = toFixedFloat(
      initialLabourAmount +
      toFixedFloat(otherCharges) +
      updatedData.gstLabAmt -
      updatedData.discLabAmount
    );

    updatedData.gstGlassAmt = toFixedFloat((initialGlassAmount / 1.18) * 0.18);
    updatedData.discGlassAmount = toFixedFloat(
      (initialGlassAmount * discOnGlassAmt) / 100
    );
    updatedData.glassAmount = toFixedFloat(
      initialGlassAmount +
      toFixedFloat(otherChargesGlass) -
      (updatedData.discGlassAmount + updatedData.gstGlassAmt)
    );



    console.log("Show GST GLASs", updatedData.showGSTGlass);
    if (updatedData.showGSTGlass == '1') {
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt + updatedData.gstGlassAmt
      );
      console.log("Going Inside");
    } else {
      console.log("Evertythinh", updatedData.labourAmount, updatedData.glassAmount, updatedData.gstGlassAmt);
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount + updatedData.gstGlassAmt - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt
      );

    }
    updatedData.netAmount = toFixedFloat(
      updatedData.totalAmount + updatedData.gstAmount
    );
    updatedData.afterAdvanceNetAmount = toFixedFloat(
      updatedData.netAmount - advance
    );

    setQuotationData(updatedData);
  };

  const handleLabourChange = (event) => {
    let initialTotalAmount = 0;
    let initialLabourAmount = 0;
    let initialGlassAmount = 0;

    items.forEach((item) => {
      const amount = toFixedFloat(item.amount);
      initialTotalAmount += amount;
      if (item.item_type_id === 1) {
        initialGlassAmount += amount;
      }
      if (item.item_type_id === 2) {
        initialLabourAmount += amount;
      }
    });

    const { name, value } = event.target;
    const updatedData = {
      ...quotationData,
      [name]: value.length <= 0 ? 0 : toFixedFloat(value),
      labourAmount: initialLabourAmount,
    };

    const {
      labourAmount,
      otherCharges = 0,
      gstLabAmtPercent = 0,
      discOnLabAmt = 0,
    } = updatedData;

    updatedData.discLabAmount = (labourAmount * discOnLabAmt) / 100;
    console.log("RRRR", (labourAmount * discOnLabAmt) / 100);
    updatedData.gstLabAmt = toFixedFloat(
      (labourAmount * gstLabAmtPercent) / 100
    );
    updatedData.labourAmount = toFixedFloat(
      initialLabourAmount +
      toFixedFloat(otherCharges) +
      updatedData.gstLabAmt -
      updatedData.discLabAmount
    );


    if (updatedData.showGSTGlass == '1') {
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt + updatedData.gstGlassAmt
      );
      console.log("Going Inside");
    } else {
      console.log("Evertythinh", updatedData.labourAmount, updatedData.glassAmount, updatedData.gstGlassAmt);
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount + updatedData.gstGlassAmt - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt
      );

    }
    updatedData.netAmount = toFixedFloat(
      updatedData.totalAmount + updatedData.gstAmount
    );

    updatedData.afterAdvanceNetAmount = toFixedFloat(
      updatedData.netAmount - updatedData.advance
    );
    console.log("Updated Data----->>>>>>", updatedData);

    setQuotationData(updatedData);
  };

  const handleGlassChange = (event) => {
    let initialTotalAmount = 0;
    let initialLabourAmount = 0;
    let initialGlassAmount = 0;

    items.forEach((item) => {
      const amount = toFixedFloat(item.amount);
      initialTotalAmount += amount;
      if (item.item_type_id === 1) {
        initialGlassAmount += amount;
      }
      if (item.item_type_id === 2) {
        initialLabourAmount += amount;
      }
    });

    const { name, value } = event.target;
    const updatedData = {
      ...quotationData,
      [name]: value.length <= 0 ? 0 : toFixedFloat(value),
      glassAmount: initialGlassAmount,
    };

    const {
      glassAmount,
      otherChargesGlass = 0,
      gstGlassAmtPercent = 0,
      discOnGlassAmt = 0,
    } = updatedData;

    updatedData.gstGlassAmt = toFixedFloat((initialGlassAmount / 1.18) * 0.18);
    updatedData.discGlassAmount = toFixedFloat(
      (glassAmount * discOnGlassAmt) / 100
    );
    updatedData.glassAmount = toFixedFloat(
      toFixedFloat(glassAmount) +
      toFixedFloat(otherChargesGlass) -
      (updatedData.discGlassAmount + updatedData.gstGlassAmt)
    );


    if (updatedData.showGSTGlass == '1') {
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt + updatedData.gstGlassAmt
      );
      console.log("Going Inside");
    } else {
      console.log("Evertythinh", updatedData.labourAmount, updatedData.glassAmount, updatedData.gstGlassAmt);
      updatedData.totalAmount = toFixedFloat(
        updatedData.labourAmount + updatedData.glassAmount + updatedData.gstGlassAmt - updatedData.gstLabAmt
      );

      updatedData.gstAmount = toFixedFloat(
        updatedData.gstLabAmt
      );

    }
    updatedData.netAmount = toFixedFloat(
      updatedData.totalAmount + updatedData.gstAmount
    );

    updatedData.afterAdvanceNetAmount = toFixedFloat(
      updatedData.netAmount - updatedData.advance
    );

    setQuotationData(updatedData);
  };

  const handleBalanceChange = (event) => {
    const { name, value } = event.target;

    const updatedData = {
      ...quotationData,
      [name]: value.length <= 0 ? 0 : toFixedFloat(value),
    };

    updatedData.afterAdvanceNetAmount = toFixedFloat(
      updatedData.netAmount - updatedData.advance
    );
    setQuotationData(updatedData);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setQuotationData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value,
      };

      // Calculate values with defined variables

      return {
        ...updatedData,
      };
    });
  };

  const handleItemChange = async (index, name, value) => {
    console.log(
      `Handling change for item at index ${index}: { name: ${name}, value: ${value} }`
    );

    const updatedItems = [...items]; // Create a copy of the current items
    let cumulativeGlassSquareFeet = 0; // Initialize cumulative glass square feet
    let lastGlassGRNo = 0; // Initialize last glass GR number

    // Set manualOverride flag if quantity is manually changed
    if (name === "quantity") {
      updatedItems[index].manualOverride = true;
    }

    if (name === "code") {
      // console.log(`Updating code for item at index ${index}: ${value}`);
      updatedItems[index].code = value;
      // Debounce the fetching part
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setItems(updatedItems); // Update state immediately for the code input

      timeoutRef.current = setTimeout(async () => {
        const { itemName, unitShort, itemTypeId } = await fetchItemData(value);
        
        setItems((prevItems) => {
          const latestItems = [...prevItems];
          if (latestItems[index]) {
            latestItems[index].name = itemName;
            latestItems[index].unit_short = unitShort;
            latestItems[index].item_type_id = itemTypeId;

            // Sync rate from existing items with same code
            if (value !== "") {
              const existingItemWithRate = latestItems.find((item, idx) => item.code === value && idx !== index && item.rate);
              if (existingItemWithRate) {
                latestItems[index].rate = existingItemWithRate.rate;
                // Calculate amount for the current item with the synced rate
                const rateVal = parseFloat(existingItemWithRate.rate) || 0;
                const sqFt = parseFloat(latestItems[index].squareFeet) || 0;
                latestItems[index].amount = parseFloat((sqFt * rateVal).toFixed(3));
              }
            }

            // grNo logic needs to be reapplied because it depends on item_type_id
            if (itemTypeId === 1) {
              if (value === "") {
                latestItems[index].grNo = 0;
              } else {
                const lastGlassGRNo = latestItems.reduce((maxGrNo, item, idx) => {
                  if (item.item_type_id === 1 && item.grNo && idx !== index) {
                    return Math.max(maxGrNo, item.grNo);
                  }
                  return maxGrNo;
                }, 0);
                if (!latestItems[index].grNo) {
                  latestItems[index].grNo = lastGlassGRNo + 1;
                }
              }
            } else if (itemTypeId === 2) {
              const previousGlassItem = latestItems
                .slice(0, index)
                .reverse()
                .find((prevItem) => prevItem.item_type_id === 1);
              if (previousGlassItem) {
                const laborInitial = itemName.charAt(0);
                latestItems[index].grNo = `${laborInitial}${previousGlassItem.grNo}`;
              }
            }

            // Re-calculate square feet and amount after fetching details
            const length = parseFloat(latestItems[index].length) || 0;
            const width = parseFloat(latestItems[index].width) || 0;
            const quantity = parseFloat(latestItems[index].quantity) || 1;
            const rate = parseFloat(latestItems[index].rate) || 0;
            const calculationBy = parseFloat(latestItems[index].calculationBy) || 6;

            if (length === 0 && width === 0) {
              if (value !== "25" && value !== "393") {
                latestItems[index].squareFeet = parseFloat(quantity.toFixed(3));
              }
            } else {
              const adjustedLength = Math.floor(length / 12) + Math.ceil((length % 12) / calculationBy) * (calculationBy / 12);
              const adjustedWidth = Math.floor(width / 12) + Math.ceil((width % 12) / calculationBy) * (calculationBy / 12);
              if (value !== "25" && value !== "393") {
                latestItems[index].squareFeet = parseFloat(((adjustedLength * adjustedWidth) * quantity).toFixed(3));
              }
            }
            latestItems[index].amount = parseFloat((parseFloat(latestItems[index].squareFeet || 0) * rate).toFixed(3));

            // Run processItems logic (simplified for the single item or just call everything)
            // For now, these calculations cover the basics.
          }
          return latestItems;
        });
        handleItemWiseValueChange();
      }, 0);
      return; // Exit early as we've handled the code change through debounce
    } else {
      updatedItems[index][name] = value; // Update the specified field
      // console.log(`Updated ${name} for index ${index} to ${value}`);

      // Sync rates if rate is changed
      if (name === "rate" && updatedItems[index].code) {
        const newRate = parseFloat(value) || 0;
        updatedItems.forEach((item, idx) => {
          if (idx !== index && item.code === updatedItems[index].code) {
            item.rate = value;
            // Update amount for the synchronized item
            item.amount = parseFloat((parseFloat(item.squareFeet || 0) * newRate).toFixed(3));
          }
        });
      }
    }

    const length = parseFloat(updatedItems[index].length) || 0;
    const width = parseFloat(updatedItems[index].width) || 0;
    const quantity = parseFloat(updatedItems[index].quantity) || 1; // Default quantity is 1
    const rate = parseFloat(updatedItems[index].rate) || 0;
    const calculationBy = parseFloat(updatedItems[index].calculationBy) || 6;

    // console.log(
    //   `Calculating square feet for item at index ${index}: { length: ${length}, width: ${width}, quantity: ${quantity}, rate: ${rate}, calculationBy: ${calculationBy} }`
    // );

    // Calculate square feet for glass
    if (length === 0 && width === 0) {
      if (
        updatedItems[index].code != "25" &&
        updatedItems[index].code != "393"
      ) {
        // console.log("HGHGHGHGHGHGHGHJGGHTRTRT");
        updatedItems[index].squareFeet = parseFloat(quantity.toFixed(3));
      }
    } else {
      // const adjustedLength = Math.ceil(length / calculationBy) * calculationBy;
      const adjustedLength = Math.floor(length / 12) + Math.ceil((length % 12) / calculationBy) * (calculationBy / 12);
      const adjustedWidth = Math.floor(width / 12) + Math.ceil((width % 12) / calculationBy) * (calculationBy / 12);

      if (
        updatedItems[index].code != "25" ||
        updatedItems[index].code != "393"
      ) {
        // console.log("EEEEEEEEEEEEEEEEEEEEEWEFWFSFDFSDFF");
        updatedItems[index].squareFeet = parseFloat(
          (((adjustedLength * adjustedWidth)) * quantity).toFixed(3)
        );
      }
    }

    // Calculate the amount based on square feet and rate

    // console.log(
    //   "Updated Items",
    //   updatedItems,
    //   updatedItems[index].amount,
    //   updatedItems[index].squareFeet,
    //   updatedItems[index],
    //   updatedItems[index].squareFeet
    // );
    updatedItems[index].amount = parseFloat(
      (parseFloat(updatedItems[index].squareFeet) * rate).toFixed(3)
    );
    // console.log(
    //   `Updated item at index ${index}: { squareFeet: ${updatedItems[index].squareFeet}, amount: ${updatedItems[index].amount} }`
    // );

    // Calculate cumulative square feet for glass items
    for (let i = 0; i <= index; i++) {
      const currentItem = updatedItems[i];
      if (currentItem.item_type_id === 1) {
        // Check for glass items

        cumulativeGlassSquareFeet += currentItem.squareFeet; // Accumulate square feet
      }
    }

    // Update squareFeet for Labour Charges based on cumulative glass square feet
    if (
      updatedItems[index].item_type_id === 2 &&
      updatedItems[index].code === "100"
    ) {
      // Check for Labour Charges code
      updatedItems[index].squareFeet = (cumulativeGlassSquareFeet).toFixed(3); // Set square feet
      // console.log(
      //   `Updated squareFeet for Labour Charges at index ${index}: ${cumulativeGlassSquareFeet}`
      // );

      // Calculate amount for Labour Charges
      updatedItems[index].amount = parseFloat(
        (cumulativeGlassSquareFeet * rate).toFixed(2)
      ); // Update amount
      // console.log(
      //   `Updated amount for Labour Charges at index ${index}: ${updatedItems[index].amount}`
      // );
    }

    // Calculate total amounts for glass and labour

    // Assign GR numbers for labor items based on the last glass item's GR number
    updatedItems.forEach((item, idx) => {
      if (item.item_type_id === 2) {
        // Check if it's a labor item
        const previousGlassItem = updatedItems
          .slice(0, idx)
          .reverse()
          .find((prevItem) => prevItem.item_type_id === 1);
        if (previousGlassItem) {
          const laborInitial = item.name.charAt(0); // Get the initial of the labor type (e.g., 'H' for hole)
          item.grNo = `${laborInitial}${previousGlassItem.grNo}`; // Assign new GR number
          // console.log(
          //   `Updated grNo for labor item at index ${idx} to ${item.grNo}`
          // );
        }
      }
    });

    let glassItemGrNos = {};

    // Process items for glass item GR numbers and DEP calculations
    function processItems(updatedItems, calculationBy) {
      let currentGlassDEPTotal = 0; // Initialize DEP for the current glass section
      let lastGlassSqFt = 0; // Track the last calculated square feet for glass items
      let lastGlassQty = 0;
      let allGlassSqFtTotal = 0;
      let allGlassQtyTotal = 0;

      updatedItems.forEach((item, idx) => {
        // Handle GR No assignment for labour
        if (item.item_type_id === 2) {
          const nearestGlassIndex = Object.keys(glassItemGrNos).reduce(
            (prev, curr) => {
              return idx > curr ? curr : prev;
            },
            null
          );

          if (nearestGlassIndex !== null) {
            updatedItems[idx].grNo = `${item.name.charAt(0)}${glassItemGrNos[nearestGlassIndex]
              }`;
            // console.log(
            //   `Updated grNo for item at index ${idx} to ${updatedItems[idx].grNo}`
            // );
          }
        }

        // Identify glass items
        if (item.item_type_id === 1) {
          const length = parseFloat(item.length) || 0;
          const width = parseFloat(item.width) || 0;
          const quantity = item.quantity || "";
          const quantity1 = item.quantity || "";
          // Validate dimensions and calculate DEP
          if (!isNaN(length) && !isNaN(width)) {
            const adjustedLength =
              (Math.ceil(length / calculationBy) * calculationBy) / 12;
            const adjustedWidth =
              (Math.ceil(width / calculationBy) * calculationBy) / 12;
            const singleGlassDEP = (adjustedLength + adjustedWidth) * 2; // Total DEP for the glass item
            // console.log("SSSSS", singleGlassDEP);
            const totalGlassDEP = singleGlassDEP * quantity; // Total DEP for the current item
            // console.log("TTTTT", totalGlassDEP);
            if (
              item.item_type_id === 1 &&
              idx > 0 &&
              updatedItems[idx - 1].item_type_id === 1
            ) {
              console.log("How many times", item, updatedItems.length, idx);
              currentGlassDEPTotal += totalGlassDEP;
            } else if (item.item_type_id === 1 && idx == 0) {
              console.log("First Time", item, updatedItems.length, idx);
              currentGlassDEPTotal += totalGlassDEP;
            } else if (
              item.item_type_id === 1 &&
              idx > 0 &&
              updatedItems[idx - 1].item_type_id !== 1
            ) {
              console.log(
                "At what item hitting",
                item,
                updatedItems.length,
                idx
              );
              currentGlassDEPTotal = totalGlassDEP;
            }
            allGlassQtyTotal += item.quantity;
            allGlassSqFtTotal += item.squareFeet;
            // lastGlassSqFt = adjustedLength * adjustedWidth * quantity; // Square feet calculation

            // console.log("**********Length -- ", quantity1);
            // console.log(
            //   `*******************Calculated SqFt for glass item at index ${idx}: ${lastGlassSqFt.toFixed(
            //     2
            //   )}`
            // );
            // console.log(
            //   `Calculated DEP for glass item at index ${idx}: ${totalGlassDEP.toFixed(
            //     1
            //   )}`
            // );
          }
        }
        console.log("CGDT", currentGlassDEPTotal, allGlassSqFtTotal);
        // Handle items with code 265 (DEP separator)

        if (item.unit_short === "S") {
          console.log("Hitting", item.code);

          updatedItems.forEach((item, idx) => {
            // Handle sum accumulation for item_type_id === 1
            if (
              item.item_type_id === 1 &&
              idx > 0 &&
              updatedItems[idx - 1].item_type_id === 1
            ) {
              console.log("How many times", item, updatedItems.length, idx);
              lastGlassSqFt += item.squareFeet;
              (lastGlassQty += item.quantity);
            } else if (item.item_type_id === 1 && idx == 0) {
              console.log("First Time", item, updatedItems.length, idx);
              lastGlassSqFt += item.squareFeet;
              (lastGlassQty += item.quantity);
            } else if (
              item.item_type_id === 1 &&
              idx > 0 &&
              updatedItems[idx - 1].item_type_id !== 1
            ) {
              console.log(
                "At what item hitting",
                item,
                updatedItems.length,
                idx
              );
              lastGlassSqFt = item.squareFeet;
              lastGlassQty = item.quantity;
            }

            if (
              item.item_type_id === 2 &&
              item.unit_short === "S" &&
              item.code !== "265"
            ) {
              item.quantity = "";
              console.log("Setting", lastGlassSqFt, "to", item);
              item.squareFeet = parseFloat(lastGlassSqFt).toFixed(3); // Assign sum to sequence
              item.quantity = lastGlassQty;
              item.amount = parseFloat(item.squareFeet) * parseFloat(item.rate);
            } else if (item.item_type_id === 2 && item.unit_short === "P") {
              item.quantity = item.quantity;
              item.amount = parseFloat(item.quantity) * parseFloat(item.rate);
              item.squareFeet = "";
            }
            if (idx === updatedItems.length - 1) {
              lastGlassSqFt = 0;
              lastGlassQty = 0;
            }
            console.log("LLLLGGGSSSFFFTTT", lastGlassSqFt);
          });

          // updatedItems[idx].squareFeet = lastGlassSqFt.toFixed(0);
          // console.log(
          //   `Updated quantity for item 265 at index ${idx} to ${updatedItems[idx].quantity}`
          // );
        }
        if (item.unit_short === "R") {
          // console.log("RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR", updatedItems);
          // Only update quantity if no manual over
          updatedItems[idx].quantity = currentGlassDEPTotal.toFixed(0);
          updatedItems[idx].squareFeet = currentGlassDEPTotal.toFixed(0);

          // console.log(
          //   `Updated quantity for item 265 at index ${idx} to ${updatedItems[idx].quantity}`
          // );
        }
        if (idx === updatedItems.length - 1) {
          currentGlassDEPTotal = 0;
        }
      });

      return updatedItems;
    }

    // Process the updated items for DEP calculations
    const result = processItems(updatedItems, calculationBy);
    setItems(updatedItems);
    handleItemWiseValueChange();
  };

  const addNewItem = () => {
    const newItem = {
      code: "",
      name: "",
      length: "",
      width: "",
      cal: "",
      quantity: "",
      squareFeet: "",
      rate: "",
      amount: "",
      grNo: "",
    };

    setItems((prevItems) => [...prevItems, newItem]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const newQuotation = { ...quotationData };
    let initialTotalAmount = 0;

    let initialLabourAmount = 0;

    let initialGlassAmount = 0;

    items.forEach((item) => {
      initialTotalAmount += parseFloat(item.amount) || 0;
      if (item.item_type_id === 1) {
        initialGlassAmount += parseFloat(item.amount) || 0;
      }
      if (item.item_type_id === 2) {
        initialLabourAmount += parseFloat(item.amount) || 0;
      }
    });

    // New Quotation data after calculations
    newQuotation.initialTotalAmount = initialTotalAmount;

    newQuotation.initialLabourAmount = initialLabourAmount;

    newQuotation.initialGlassAmount = initialGlassAmount;
    newQuotation.totalAmount = parseFloat(quotationData.totalAmount);
    newQuotation.balance = parseFloat(quotationData.afterAdvanceNetAmount);

    console.log("New Quotation", newQuotation);
    if (!quotationData.partyName) {
      setModalMessage("Party Name is required");
      setShowModal(true);
      return;
    }
    if (!quotationData.showCName) {
      setModalMessage(
        "Please select whether to show the company name in the quotation."
      );
      setShowModal(true);
      return;
    }
    const apiEndpoint = `${apiUrl}/admin/createQuotation`;

    const submissionData = {
      quotationData: newQuotation,
      items,
    };
    console.log(submissionData);

    try {
      const response = await axios.post(apiEndpoint, submissionData, {
        headers: {
          api_token: token, // Include the token in the Authorization header
          "Content-Type": "application/json",
        },
        responseType: "blob", // Set response type to blob to handle binary data (PDF)
      });

      // Create a blob URL and open the PDF in a new tab
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank"); // Opens the PDF in a new tab

      console.log("Submission successful:", response.data);

      // // Refresh the page after a successful submission
      // window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
      // Optionally handle the error (e.g., show a notification)
    }
    setIsLoading(false);

  };
  // const handleButtonClick = async (e) => {
  //     e.preventDefault();
  //     const isConfirmed = window.confirm("Do you want to generate the quotation?");
  //     if (isConfirmed) {
  //         handleSubmit(e);
  //     }
  // };

  useEffect(() => {
    // Function to fetch quotation number from API
    const fetchQuotationNo = async () => {
      try {
        const response = await axios.get(`${apiUrl}/admin/getQuotationNo`, {
          headers: {
            api_token: token,
          },
        });
        if (response.data.status) {
          setQuotationData((prevData) => ({
            ...prevData,
            quotationNo: response.data.data.quotNo,
          }));
        } else {
          console.log("Failed to fetch quotation number.");
        }
      } catch (error) {
        console.error("Error fetching quotation number:", error);
      }
    };

    fetchQuotationNo();
  }, []);

  useEffect(() => {
    if (!quotationData.calculationBy) return;

    const calculationBy = parseFloat(quotationData.calculationBy);
    if (isNaN(calculationBy) || calculationBy <= 0) return;

    const updatedItems = items.map((item) => {
      if (!item.code) return item;

      const length = parseFloat(item.length) || 0;
      const width = parseFloat(item.width) || 0;
      const quantity = parseFloat(item.quantity) || 1;
      const rate = parseFloat(item.rate) || 0;

      let squareFeet = 0;

      if (length === 0 && width === 0) {
        squareFeet = quantity;
      } else {
        const adjustedLength =
          Math.floor(length / 12) +
          Math.ceil((length % 12) / calculationBy) * (calculationBy / 12);
        const adjustedWidth =
          Math.floor(width / 12) +
          Math.ceil((width % 12) / calculationBy) * (calculationBy / 12);

        squareFeet = parseFloat(
          (((adjustedLength * adjustedWidth)) * quantity).toFixed(3)
        );
      }

      const amount = parseFloat((squareFeet * rate).toFixed(3));

      return {
        ...item,
        squareFeet,
        amount,
      };
    });

    setItems(updatedItems);
    handleItemWiseValueChange();
  }, [quotationData.calculationBy]);


  return (
    <>
      <Navbar />
      <div className="flex justify-center p-2">
        {" "}
        {/* Outer container for centering the form */}
        <div className="p-4 bg-white border border-gray-600 rounded-lg shadow-lg">
          {" "}
          {/* Border container */}
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col items-center w-full mb-4">
              <div className="grid w-full max-w-5xl grid-cols-12 gap-3">
                {" "}
                {/* Adjusted for compact layout */}
                <div className="flex flex-col col-span-1">
                  {" "}
                  {/* Quotation No. */}
                  <label className="mb-1 text-sm font-medium text-center">
                    Quot No.
                  </label>
                  <input
                    type="text"
                    name="quotationNo"
                    value={quotationData.quotationNo}
                    onChange={handleChange}
                    readOnly
                    className="w-full h-10 p-1 text-center border border-gray-300"
                  />
                </div>
                <div className="flex flex-col col-span-2">
                  {" "}
                  {/* Quot Date */}
                  <label className="mb-1 text-sm font-medium text-center">
                    Quot. Date
                  </label>
                  <input
                    type="date"
                    name="quotDate"
                    value={quotationData.quotDate}
                    onChange={handleChange}
                    className="w-full h-10 p-1 text-center border border-gray-300"
                  />
                </div>
                <div className="flex flex-col col-span-2">
                  {" "}
                  {/* Calculation By */}
                  <label className="mb-1 text-sm font-medium text-center">
                    Calculation By
                  </label>
                  <input
                    type="text"
                    name="calculationBy"
                    value={quotationData.calculationBy}
                    onChange={handleCalculationByChange}
                    className="w-full h-10 p-1 text-center border border-gray-300"
                  />
                </div>
                <div className="flex flex-col col-span-1">
                  {" "}
                  {/* C/O Id */}
                  <label className="mb-1 text-sm font-medium text-center">
                    C/O Id
                  </label>
                  <input
                    type="text"
                    name="coId"
                    value={quotationData.coId}
                    onChange={handleInputChange}
                    className="w-full h-10 p-1 text-center border border-gray-300"
                  />
                </div>
                <div className="flex flex-col col-span-2">
                  {" "}
                  {/* Ref. Person Name */}
                  <label className="mb-1 text-sm font-medium text-center">
                    Ref. Person Name
                  </label>
                  <input
                    type="text"
                    name="refPerson"
                    value={quotationData.refPerson}
                    onChange={handleInputChange}
                    readOnly
                    className="w-full h-10 p-1 text-center border border-gray-300"
                  />
                </div>
                <div className="flex flex-col col-span-2">
                  {" "}
                  {/* Party Name */}
                  <label className="mb-1 text-sm font-medium text-center">
                    Party Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="partyName"
                    value={quotationData.partyName}
                    onChange={handleChange}
                    className="w-full h-10 p-1 text-center border border-gray-300"
                    required
                  />
                </div>
                <div className="flex flex-col col-span-2">
                  {" "}
                  {/* Party Person Name */}
                  <label className="mb-1 text-sm font-medium text-center">
                    Party Person Name
                  </label>
                  <input
                    type="text"
                    name="partyPersonName"
                    value={quotationData.partyPersonName}
                    onChange={handleChange}
                    className="w-full h-10 p-1 text-center border border-gray-300"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              <div className="flex items-center justify-center w-full max-w-screen-lg space-x-4 overflow-hidden">
                <table className="w-full mt-5 mb-4 border border-collapse border-gray-300 rounded-lg">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="p-3 text-center border border-gray-300">
                        Sr No
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Gr No
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Item Code
                        <span
                          className="ml-1 cursor-pointer"
                          onClick={openModal}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="size-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                            />
                          </svg>
                        </span>
                      </th>
                      <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={closeModal}
                        className="w-11/12 max-w-6xl p-5 mx-auto bg-white rounded-lg shadow-lg"
                        overlayClassName="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
                      >
                        <div className="flex flex-col items-center w-full max-w-screen-xl p-8">
                          {loading ? (
                            <p className="text-center">Loading...</p>
                          ) : (
                            <div className="w-full flex h-[80vh] space-x-4 overflow-hidden">
                              {/* Section for item_type_id=1 (Items) */}
                              <div className="flex-1 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-md">
                                <h2 className="mb-4 text-xl font-bold text-center">
                                  Items
                                </h2>
                                <div className="px-4 mb-4">
                                  <input
                                    type="text"
                                    placeholder="Search Items"
                                    value={itemSearch} // Ensure itemSearch is part of your state
                                    onChange={(e) =>
                                      setItemSearch(
                                        e.target.value.toLowerCase()
                                      )
                                    }
                                    className="w-full p-2 border border-gray-300 rounded-lg"
                                  />
                                </div>
                                <table className="w-full border border-collapse border-gray-300">
                                  <thead>
                                    <tr>
                                      <th className="px-6 py-4 text-center border border-gray-300 text-md">
                                        Item Code
                                      </th>
                                      <th className="px-6 py-4 text-center border border-gray-300 text-md">
                                        Item Name
                                      </th>
                                      <th className="px-6 py-4 text-center border border-gray-300 text-md">
                                        Unit
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredItemMasters
                                      .filter(
                                        (item) =>
                                          item.item_type_id === 1 &&
                                          (item.item_code
                                            .toLowerCase()
                                            .includes(itemSearch) ||
                                            item.item_name
                                              .toLowerCase()
                                              .includes(itemSearch))
                                      )
                                      .map((itemMaster) => (
                                        <tr
                                          key={itemMaster.item_id}
                                          className="even:bg-gray-100"
                                        >
                                          <td className="px-6 py-4 text-center border border-gray-300 text-md">
                                            {itemMaster.item_code}
                                          </td>
                                          <td className="px-6 py-4 text-center border border-gray-300 text-md">
                                            {itemMaster.item_name}
                                          </td>
                                          <td className="px-6 py-4 text-center border border-gray-300 text-md">
                                            {itemMaster.unit_name}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>

                              {/* Section for item_type_id=2 (Labours) */}
                              <div className="flex-1 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-md">
                                <h2 className="mb-4 text-xl font-bold text-center">
                                  Labours
                                </h2>
                                <div className="px-4 mb-4">
                                  <input
                                    type="text"
                                    placeholder="Search Labours"
                                    value={labourSearch} // Ensure labourSearch is part of your state
                                    onChange={(e) =>
                                      setLabourSearch(
                                        e.target.value.toLowerCase()
                                      )
                                    }
                                    className="w-full p-2 border border-gray-300 rounded-lg"
                                  />
                                </div>
                                <table className="w-full border border-collapse border-gray-300">
                                  <thead>
                                    <tr>
                                      <th className="px-6 py-4 text-center border border-gray-300 text-md">
                                        Item Code
                                      </th>
                                      <th className="px-6 py-4 text-center border border-gray-300 text-md">
                                        Item Name
                                      </th>
                                      <th className="px-6 py-4 text-center border border-gray-300 text-md">
                                        Unit
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredItemMasters
                                      .filter(
                                        (item) =>
                                          item.item_type_id === 2 &&
                                          (item.item_code
                                            .toLowerCase()
                                            .includes(labourSearch) ||
                                            item.item_name
                                              .toLowerCase()
                                              .includes(labourSearch))
                                      )
                                      .map((itemMaster) => (
                                        <tr
                                          key={itemMaster.item_id}
                                          className="even:bg-gray-100"
                                        >
                                          <td className="px-6 py-4 text-center border border-gray-300 text-md">
                                            {itemMaster.item_code}
                                          </td>
                                          <td className="px-6 py-4 text-center border border-gray-300 text-md">
                                            {itemMaster.item_name}
                                          </td>
                                          <td className="px-6 py-4 text-center border border-gray-300 text-md">
                                            {itemMaster.unit_name}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                          <div className="mt-6">
                            <button
                              onClick={closeModal}
                              className="px-5 py-2 text-white transition duration-200 bg-blue-600 rounded-lg hover:bg-blue-700"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Modal>

                      <th className="p-3 text-center border border-gray-300">
                        Name
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Length (inches)
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        X
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Width (inches)
                      </th>
                      <th className="p-5 text-center border border-gray-300">
                        Cal
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Quantity
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Square Feet
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Rate
                      </th>
                      <th className="p-3 text-center border border-gray-300">
                        Amount
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td className="p-3 text-center border border-gray-300">
                          {index + 1}
                        </td>
                        <td className="p-3 text-center border border-gray-300">
                          {item.grNo}
                        </td>
                        <td className="p-3 border border-gray-300">
                          <input
                            type="text"
                            value={item.code}
                            onInput={(e) =>
                              handleItemChange(index, "code", e.target.value)
                            }
                            onKeyDown={(e) => handleKeyDown(index, 1, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                            disabled={isDisabled}
                          />
                        </td>
                        <td className="p-3 text-center border border-gray-300">
                          {item.name}
                        </td>
                        <td className="p-3 border border-gray-300">
                          <input
                            type="number"
                            value={item.length}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "length",
                                parseFloat(e.target.value) || 0
                              )
                            }
                            onKeyDown={(e) => handleKeyDown(index, 3, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                            disabled={isDisabled || item.item_type_id === 2} // Disable if item_type_id is 2
                          />
                        </td>
                        <td className="p-3 text-center border border-gray-300">
                          X
                        </td>
                        <td className="p-3 border border-gray-300">
                          <input
                            type="number"
                            value={item.width}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "width",
                                parseFloat(e.target.value) || 0
                              )
                            }
                            onKeyDown={(e) => handleKeyDown(index, 5, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                            disabled={isDisabled || item.item_type_id === 2} // Disable if item_type_id is 2
                          />
                        </td>
                        <td className="p-3 px-3 text-center border border-gray-300">
                          <select
                            value={item.calculationBy || quotationData.calculationBy}
                            onChange={(e) =>
                              handleItemChange(index, "calculationBy", e.target.value)
                            }
                            className="w-full p-1 text-center border"
                          >
                            <option value="">Select</option>

                            <option value="3">3</option>
                            <option value="6">6</option>
                            <option value="9">9</option>
                            <option value="12">12</option>
                          </select>
                        </td>
                        <td className="p-3 border border-gray-300">
                          <input
                            type="number"
                            value={item.quantity} // Assuming 'item.quantity' is already being managed correctly
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "quantity",
                                parseFloat(e.target.value) || 0
                              )
                            }
                            onKeyDown={(e) => handleKeyDown(index, 7, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                            disabled={isDisabled}
                          />
                        </td>
                        <td className="p-3 text-center border border-gray-300">
                          {item.squareFeet}
                        </td>
                        <td className="p-3 border border-gray-300">
                          <input
                            type="number"
                            value={item.rate}
                            onChange={(e) =>
                              handleItemChange(
                                index,
                                "rate",
                                parseFloat(e.target.value) || 0
                              )
                            }
                            onKeyDown={(e) => handleKeyDown(index, 9, e)}
                            className="w-full p-2 border border-gray-300 rounded-md"
                            disabled={isDisabled}
                            placeholder={item.unit_short || "Unit"} // Display unit_short as placeholder
                          />
                        </td>
                        <td className="p-3 border border-gray-300">
                          <div className="flex items-center">
                            {/* Input field */}
                            <input
                              type="number"
                              value={item.amount}
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "amount",
                                  parseFloat(e.target.value) || 0
                                )
                              }
                              onKeyDown={(e) => handleKeyDown(index, 10, e)}
                              className="w-full p-2 border border-gray-300 rounded-md"
                            />

                            {/* Show the red cross icon only for non-initial empty rows */}
                            {index > 0 &&
                              !item.code.length > 0 && ( // Check if the row is empty
                                <button
                                  onClick={() => removeItem(index)}
                                  className="ml-2 text-red-500 focus:outline-none" // ml-2 for some space between the input and button
                                >
                                  {/* Red cross SVG */}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                </button>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* First Row for Glass Amount, Labour Amount, and Total Amount */}
            <div className="flex items-center justify-center mt-5">
              <div className="flex flex-col items-center mb-4">
                <div className="grid max-w-screen-lg grid-cols-1 gap-4 mt-3 md:grid-cols-4">
                  <div className="flex flex-col">
                    <label className="text-sm font-medium whitespace-nowrap">
                      Disc On Labour Amount
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="number"
                        name="discOnLabAmt"
                        value={quotationData.discOnLabAmt}
                        onChange={(e) => {
                          handleLabourChange(e);
                        }}
                        className="border border-gray-300 p-2 max-w-[70px]"
                        placeholder="%"
                        disabled={isDisabled}
                      />
                      <input
                        type="number"
                        name="discLabAmount"
                        value={quotationData.discLabAmount}
                        readOnly
                        className="w-full p-2 border border-gray-300"
                        placeholder="Discounted Amount"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium whitespace-nowrap">
                      Other Charges on Labour
                    </label>
                    <input
                      type="number"
                      name="otherCharges"
                      value={quotationData.otherCharges}
                      onChange={(e) => {
                        handleLabourChange(e);
                      }}
                      className="p-2 border border-gray-300"
                      disabled={isDisabled}
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium">
                      GST on Labour Amt %
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="number"
                        name="gstLabAmtPercent"
                        value={quotationData.gstLabAmtPercent}
                        onChange={(e) => {
                          handleLabourChange(e);
                        }}
                        className="border border-gray-300 p-2 max-w-[70px]"
                        placeholder="%"
                        disabled={isDisabled}
                      />
                      <input
                        type="number"
                        name="gstLabAmt"
                        value={quotationData.gstLabAmt}
                        readOnly
                        className="w-full p-2 border border-gray-300"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm font-medium">Labour Amount</label>
                    <input
                      type="number"
                      name="labourAmount"
                      value={quotationData.labourAmount}
                      readOnly
                      className="p-2 border border-gray-300 "
                    />
                  </div>
                </div>

                <div className="grid max-w-screen-lg grid-cols-1 gap-4 mt-3 md:grid-cols-4">
                  <div className="flex flex-col">
                    <label className="text-sm font-medium whitespace-nowrap">
                      Disc On Glass Amount
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="number"
                        name="discOnGlassAmt"
                        value={quotationData.discOnGlassAmt}
                        onChange={(e) => {
                          handleGlassChange(e);
                        }}
                        className="border border-gray-300 p-2 max-w-[70px]"
                        placeholder="%"
                        disabled={isDisabled}
                      />
                      <input
                        type="number"
                        name="discGlassAmount"
                        value={quotationData.discGlassAmount}
                        readOnly
                        className="w-full p-2 border border-gray-300"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium">
                      Other Charges on Glass
                    </label>
                    <input
                      type="number"
                      name="otherChargesGlass"
                      value={quotationData.otherChargesGlass}
                      onChange={(e) => {
                        handleGlassChange(e);
                      }}
                      className="p-2 border border-gray-300"
                      disabled={isDisabled}
                    />
                  </div>

                  {quotationData?.showGSTGlass == "1" && (
                    <>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium">
                          GST on Glass Amt %
                        </label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            name="gstGlassAmtPercent"
                            value={quotationData.gstGlassAmtPercent}
                            onChange={(e) => {
                              handleGlassChange(e);
                            }}
                            className="border border-gray-300 p-2 max-w-[70px]"
                            placeholder="%"
                            disabled={isDisabled}
                            readOnly
                          />
                          <input
                            type="number"
                            name="gstGlassAmt"
                            //   value={((quotationData.labourAmount - discLabAmount + quotationData.otherCharges)   * ((quotationData.gstLabAmtPercent / 100)) || 0).toFixed(2)}
                            value={quotationData.gstGlassAmt}
                            readOnly
                            className="w-full p-2 border border-gray-300"
                            disabled={isDisabled}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col">
                        <label className="text-sm font-medium">
                          Glass Amount
                        </label>
                        <input
                          type="number"
                          name="glassAmount"
                          value={quotationData.glassAmount}
                          readOnly
                          className="p-2 border border-gray-300"
                        />
                      </div>
                    </>
                  )}
                </div>

                <div className="grid max-w-screen-lg grid-cols-1 gap-4 mt-3 md:grid-cols-6">
                  <div className="flex flex-col">
                    <label className="text-sm font-medium">Total Amount</label>
                    <input
                      type="number"
                      name="totalAmount"
                      value={quotationData.totalAmount}
                      readOnly
                      className="p-2 border border-gray-300 "
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm font-medium"> GST Amount </label>
                    <div className="flex space-x-2">
                      <input
                        type="number"
                        name="gstAmount"
                        value={quotationData.gstAmount}
                        readOnly
                        className="w-full p-2 border border-gray-300"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium">Advance</label>
                    <input
                      type="number"
                      name="advance"
                      value={quotationData.advance}
                      onChange={(e) => {
                        handleBalanceChange(e);
                      }}
                      className="p-2 border border-gray-300"
                      disabled={isDisabled}
                    />
                  </div>
                </div>

                <div className="flex items-start justify-start w-full mt-3">
                  <div className="flex flex-col w-1/2">
                    <label className="text-sm font-medium">Remarks</label>
                    <textarea
                      name="remark"
                      value={quotationData.remark}
                      onChange={handleChange}
                      className="w-full p-2 border border-gray-300"
                    />
                  </div>
                </div>

                <div className="grid max-w-screen-lg grid-cols-1 gap-4 mt-3 md:grid-cols-8">
                  <div className="flex flex-col">
                    <label className="text-sm font-medium whitespace-nowrap">
                      Net Amount
                    </label>
                    <input
                      type="number"
                      name="netAmount"
                      value={quotationData.netAmount}
                      readOnly
                      className="p-2 border border-gray-300"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium">
                      Advance Amount
                    </label>
                    <input
                      type="number"
                      name="advance"
                      value={quotationData.advance}
                      readOnly
                      className="p-2 border border-gray-300"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium whitespace-nowrap">
                      Balance Amount
                    </label>
                    <input
                      type="number"
                      name="afterAdvanceNetAmount"
                      value={quotationData.afterAdvanceNetAmount}
                      readOnly
                      className="p-2 border border-gray-300"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="flex justify-between mt-4">
                                
                                <button type="button" className="px-4 py-2 text-black bg-gray-300 rounded">
                                    Cancel
                                </button>
                                <button type="button" className="px-4 py-2 text-white bg-red-500 rounded">
                                    Delete
                                </button>
                                <button type="button" className="px-4 py-2 text-white bg-yellow-500 rounded">
                                    Exit
                                </button>
                                <button type="button" className="px-4 py-2 text-white bg-blue-500 rounded">
                                    Print
                                </button>
                                    </div> */}

            <div className="flex flex-col items-center justify-center mt-2">
              <h3 className="mb-2 text-sm font-semibold text-gray-700">
                View and Print Glass GST in Quotation?{" "}
                <span className="text-red-500">*</span>
              </h3>

              <div className="flex items-center mb-2">
                <label className="flex items-center mr-4 cursor-pointer">
                  <input
                    type="radio"
                    name="showGSTGlass"
                    value="1"
                    onChange={handleShowGSTGlass}
                    className="w-4 h-4 mr-1 text-blue-500 form-radio"
                    required
                    checked={quotationData.showGSTGlass == "1"}
                  />

                  <span className="text-sm text-gray-600">Yes</span>
                </label>

                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="showGSTGlass"
                    value="2"
                    onChange={handleShowGSTGlass}
                    className="w-4 h-4 mr-1 text-blue-500 form-radio"
                    required
                    checked={quotationData.showGSTGlass == "2"}
                  />

                  <span className="text-sm text-gray-600">No</span>
                </label>
              </div>

              <div>
                {/* Modal */}
                {showModal && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="max-w-sm p-4 text-center bg-white rounded shadow-lg">
                      <p>{modalMessage}</p>
                      <button
                        onClick={() => setShowModal(false)}
                        className="px-4 py-2 mt-4 text-white bg-blue-500 rounded"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-2">
              <h3 className="mb-2 text-sm font-semibold text-gray-700">
                Show Company Name in Quotation?{" "}
                <span className="text-red-500">*</span>
              </h3>
              <div className="flex items-center mb-2">
                <label className="flex items-center mr-4 cursor-pointer">
                  <input
                    type="radio"
                    name="showCName"
                    value="1"
                    onChange={(e) => {
                      setQuotationData((prevData) => {
                        const updatedData = {
                          ...prevData,
                          showCName: e.target.value,
                        };
                        return {
                          ...updatedData,
                        };
                      });
                    }}
                    className="w-4 h-4 mr-1 text-blue-500 form-radio"
                    required
                    checked={quotationData.showCName == "1"}
                  />

                  <span className="text-sm text-gray-600">Yes</span>
                </label>

                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="showCName"
                    value="2"
                    onChange={(e) => {
                      setQuotationData((prevData) => {
                        const updatedData = {
                          ...prevData,
                          showCName: e.target.value,
                        };
                        return {
                          ...updatedData,
                        };
                      });
                    }}
                    className="w-4 h-4 mr-1 text-blue-500 form-radio"
                    required
                    checked={quotationData.showCName == "2"}
                  />

                  <span className="text-sm text-gray-600">No</span>
                </label>
              </div>

              <div>
                {isLoading ?
                  <button
                    type="button"
                    disabled
                    className="px-4 py-2 text-black bg-green-300 rounded"
                  >
                    Generating Quotation...
                  </button>
                  :
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="px-4 py-2 text-black bg-green-500 rounded hover:bg-green-600"
                  >
                    Generate Quotation
                  </button>
                }

                {/* Modal */}
                {showModal && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="max-w-sm p-4 text-center bg-white rounded shadow-lg">
                      <p>{modalMessage}</p>
                      <button
                        onClick={() => setShowModal(false)}
                        className="px-4 py-2 mt-4 text-white bg-blue-500 rounded"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Home;

//gst glass
{
  /* GST Amount */
}
{
  /* <div className="flex flex-col">
                                <label className="block text-sm font-medium">Glass GST Amount</label>
                                <div className="flex space-x-2">
                                    <input
                                        type="number"
                                        name="gstPercentGlass"
                                        value={quotationData.gstPercentGlass}
                                        onChange={handleChange}
                                        className="border border-gray-300 p-2 max-w-[70px]"
                                    />
                                    <input
                                        type="number"
                                        name="totalGstAmountGlass"
                                        value={quotationData.totalGstAmountGlass}
                                        onChange={handleChange}
                                        className="w-full p-2 border border-gray-300"
                                    />
                                </div>
                            </div> */
}

{
  /* <div className="grid max-w-screen-lg grid-cols-1 gap-4 mt-3 md:grid-cols-6">
                                    <div className="flex flex-col">
                                        <label className="text-sm font-medium whitespace-nowrap">Total Amount (inc Labour Discount)</label>
                                        <input
                                            type="number"
                                            name="totalAmountWithLabDisc"
                                            value={(
                                                parseFloat(quotationData.glassAmount) +
                                                parseFloat(quotationData.labourAmount) -
                                                discLabAmount
                                            ).toFixed(0)}
                                            readOnly
                                            className="p-2 border border-gray-300 "
                                        />
                                    </div>
                                </div> */
}
